import { useEffect, useState } from 'react';
import ModalCentered from '../../../components/ModalCentered';
import checkEligibleRaceClasses from '../../../utils/CheckEligibleRaceClasses';
import { updateRaceClass } from '../../../api/Registrations';
import RaceClassBulkDropdown from './RaceClassBulkDropdown';

function RaceClassBulkModal({
  raceClassBulkInfo,
  setRaceClassBulkInfo,
  competitionId,
  setRegistrations,
  setBatchSelectedRegistrations,
  setBulkRaceClassToast,
  selectedElements,
}) {
  const [elementsToMove, setElementsToMove] = useState(null);
  const [elementsUnableToBeMoved, setElementsUnableToBeMoved] = useState(null);

  useEffect(() => {
    if (raceClassBulkInfo?.selectedElements) {
      let elementsToBeMoved = [];
      let elementsNotToBeMoved = [];

      for (let i = 0; i < raceClassBulkInfo.selectedElements.length; i++) {
        const element = raceClassBulkInfo.selectedElements[i];
        const isEligibleForMove = checkEligibleRaceClasses(
          element,
          raceClassBulkInfo.raceClassItem?.value.toLowerCase()
        );

        if (isEligibleForMove) {
          elementsToBeMoved.push(element);
        } else {
          elementsNotToBeMoved.push(element);
        }
      }

      setElementsToMove(elementsToBeMoved);
      setElementsUnableToBeMoved(elementsNotToBeMoved);
    }
  }, [raceClassBulkInfo?.selectedElements, raceClassBulkInfo?.raceClassItem]);

  let body = (
    <div>
      {raceClassBulkInfo?.mobileMode && (
        <RaceClassBulkDropdown
          raceClassBulkInfo={raceClassBulkInfo}
          selectedElements={selectedElements}
          setRaceClassBulkInfo={setRaceClassBulkInfo}
          toggleBtnClasses='w-100 mb-3'
          mobileMode={true}
        />
      )}

      <p className={elementsUnableToBeMoved?.length > 0 ? '' : 'mb-0'}>
        Du kommer nu att ändra tävlingsklass på {elementsToMove?.length} objekt
        till "{raceClassBulkInfo?.raceClassItem?.name}". Tryck på "Fortsätt" för
        att bekräfta.
      </p>

      {elementsUnableToBeMoved?.length > 0 && (
        <div
          className='bg-danger-light text-danger-dark p-2 border border-danger-dark rounded'
          style={{ maxHeight: '400px', overflowY: 'auto' }}
        >
          <p>
            Följande objekt kunde inte flyttas till angiven tävlingsklass då det
            strider mot reglerna:
          </p>
          <ul>
            {elementsUnableToBeMoved.map((el) => (
              <li key={el.racingNumber}>
                Tävlande: {el.racingNumber + ' ' + el.name}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );

  const onConfirm = async () => {
    const participantIds = elementsToMove
      .filter((e) => e.participantId)
      .map((e) => e.participantId);

    const emails = elementsToMove
      .filter((e) => !e.participantId && e.participantDetails.email)
      .map((e) => e.participantDetails.email);

    const result = await updateRaceClass(
      competitionId,
      raceClassBulkInfo.raceClassItem.value,
      participantIds,
      emails
    );

    if (result.statusCode === 200) {
      setRegistrations(result.registrations);
      setRaceClassBulkInfo({
        ...raceClassBulkInfo,
        modalShow: false,
        mobileMode: false,
      });
      setBatchSelectedRegistrations([]);
      setBulkRaceClassToast({
        type: 'success',
        title: 'Ändringen av tävlingsklass lyckades!',
        body: 'De valda objektens tävlingsklass har ändrats.',
        show: true,
      });
    } else {
      setBulkRaceClassToast({
        type: 'danger',
        title: 'Ändringen av tävlingsklass misslyckades',
        body: 'De valda objektens tävlingsklass kunde inte ändras.',
        show: true,
      });
    }
  };

  return (
    <ModalCentered
      header='Genomför ändringar'
      body={body}
      show={raceClassBulkInfo?.modalShow}
      confirmBtnText='Fortsätt'
      onConfirm={onConfirm}
      onHide={() =>
        setRaceClassBulkInfo({
          ...raceClassBulkInfo,
          modalShow: false,
          mobileMode: false,
        })
      }
    />
  );
}

export default RaceClassBulkModal;
